import React from 'react';
import Typography from '../../../../components/presentational/Typography';
import { Brand } from '../../store/selectors';
import styled, { StylesProps } from '../../../../lib/styles';
import blockStyles from './Block_styles';
import Spacer from '../../../../components/presentational/Spacer';
import { compose } from 'recompose';

export interface ContentBlockData {
  type: 'content_block';
  content: any;
  title: string;
  subtitle: string;
  full_width: string;
}

interface ContentBlockProps {
  block: ContentBlockData;
  brand: Brand;
}

const ContentBlock = ({
  block: { title, subtitle, content, full_width },
  brand,
  styles,
}: ContentBlockProps & StylesProps<typeof blockStyles>) => (
  <div className={styles.container} style={{}}>
    <Spacer width={1160} align={'flex-start'}>
      <Spacer width={full_width ? 'auto' : 754} space={'xs'}>
        {subtitle && (
          <Typography weight={'normal'}>
            <h3>{subtitle}</h3>
          </Typography>
        )}
        {title && (
          <Typography>
            <h1>{title}</h1>
          </Typography>
        )}

        <Typography
          brand={brand}
          dangerouslySetInnerHTML={{ __html: content }}
          family={'primary'}
        />
      </Spacer>
    </Spacer>
  </div>
);

export default compose(styled(blockStyles))(ContentBlock);
